export const ACCESS_TYPES = {
	RESTRICTED: 'RESTRICTED',
	PUBLIC: 'PUBLIC',
	ANONYMOUS: 'ANONYMOUS',
	INTERNAL: 'INTERNAL',
} as const;

export const PORTAL_ACCESS = ACCESS_TYPES;

export const CUSTOMER_ACCESS = ACCESS_TYPES;

export type CustomerAccess = keyof typeof CUSTOMER_ACCESS;

export type PortalAccessEnum = keyof typeof PORTAL_ACCESS;

export type GlobalAccessTypeEnum =
	| typeof PORTAL_ACCESS.PUBLIC
	| typeof PORTAL_ACCESS.ANONYMOUS
	| typeof PORTAL_ACCESS.INTERNAL;

export const SHARE_REQUESTS_ACCESS = {
	AGENT_ONLY: 'AGENT_ONLY',
	EMAIL_ONLY: 'EMAIL_ONLY',
	SEARCH_AUTO_COMPLETE: 'SEARCH_AUTO_COMPLETE',
} as const;

export type ShareRequestAccessEnum = keyof typeof SHARE_REQUESTS_ACCESS;
